import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  showErrorAlert,
  showSuccessAlert,
  showSuccessEditAlert,
} from "../../../components/alerts";
import medicGeekApi from "../../../config/axiosConfig";
import "./../../../styles/FormPro.css";

const ConceptosList = ({ currentForm }) => {
  const [conceptos, setConceptos] = useState([]);
  const [showForm] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const conceptosPerPage = 10;
  const [selectedConceptoLocal, setSelectedConceptoLocal] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // Skeleton
  const [loading, setLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false);

  const [formulario, setFormulario] = useState({
    nombreConceptos: "",
    descripcionConceptos: "",
    estatusConceptos: "activo",
  });

  const openModal = (concepto) => {
    setSelectedConceptoLocal(concepto); // Configura el concepto seleccionado para la edición

    if (concepto) {
      setIsEditing(true); // Establecer como modo edición cuando se abre el modal
      setFormulario({
        nombreConcepto: concepto.conceptoNm,
        descripcionConcepto: concepto.conceptoDesc,
        estatusConcepto: concepto.estatus ? "activo" : "inactivo",
      });
    } else {
      setIsEditing(false); // Establecer como modo creación cuando se abre el modal para crear uno nuevo
      // Limpia los campos si es necesario
      setFormulario({
        nombreConcepto: "",
        descripcionConcepto: "",
        estatusConcepto: "activo",
      });
    }
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedConceptoLocal(null); // Limpia el concepto seleccionado
    setIsEditing(false); // Resetear el modo edición cuando se cierra el modal
    setModalOpen(false);
  };

  const handleSearchTermChange = (e) => {
    const searchTerm = e.target.value;
    setSearchTerm(searchTerm);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Iniciar la carga
      try {
        const response = await medicGeekApi.get(
          `/conceptos?search=${searchTerm}`,
          {
            params: {
              $or: [
                { conceptoNm: { $regex: searchTerm, $options: "i" } },
                { conceptoDesc: { $regex: searchTerm, $options: "i" } },
              ],
            },
          }
        );
        const sortedConceptos = response.data.sort(
          (a, b) => a.conceptoId - b.conceptoId
        );
        setConceptos(sortedConceptos);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false); // Finalizar carga
      }
    };

    fetchData();
  }, [searchTerm]);

  const pageCount = Math.ceil(conceptos.length / conceptosPerPage);

  const handlePageChange = ({ selected }) => {
    setPageNumber(selected);
  };

  const displayedConceptos = conceptos
    .filter((concepto) => {
      // Filtrar conceptos basados en el término de búsqueda
      return (
        concepto.conceptoNm.toLowerCase().includes(searchTerm.toLowerCase()) ||
        concepto.conceptoDesc.toLowerCase().includes(searchTerm.toLowerCase())
      );
    })
    .slice(pageNumber * conceptosPerPage, (pageNumber + 1) * conceptosPerPage);

  const updateConceptosList = () => {
    medicGeekApi
      .get("/conceptos")
      .then((response) => {
        setConceptos(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const guardarNuevoConcepto = () => {
    const nuevoConcepto = {
      conceptoNm: document.getElementById("nombreConcepto").value,
      conceptoDesc: document.getElementById("descripcionConcepto").value,
      estatus:
        document.getElementById("estatusConcepto").value === "activo"
          ? "Activo"
          : "Inactivo",
    };
    medicGeekApi
      .post("/conceptos", nuevoConcepto)
      .then((response) => {
        showSuccessAlert();
        closeModal();
        updateConceptosList();
      })
      .catch((error) => {
        console.error("Error al crear el concepto", error);
      });
  };

  const editarConcepto = () => {
    if (selectedConceptoLocal && selectedConceptoLocal.conceptoId) {
      const { conceptoId } = selectedConceptoLocal;
      const nombreConcepto = document.getElementById("nombreConcepto").value;
      const descripcionConcepto =
        document.getElementById("descripcionConcepto").value;
      const estatusConcepto =
        document.getElementById("estatusConcepto").value === "activo"
          ? "Activo"
          : "Inactivo";

      const updatedConcepto = {
        conceptoId, // Asegurarse de enviar el ID
        conceptoNm: nombreConcepto,
        conceptoDesc: descripcionConcepto,
        estatus: estatusConcepto,
      };

      medicGeekApi
        .patch(`/conceptos/${conceptoId}`, updatedConcepto)
        .then((response) => {
          showSuccessEditAlert();
          closeModal();
          updateConceptosList();
        })
        .catch((error) => {
          console.error("Error al actualizar el concepto", error);
        });
    } else {
      // Manejo de error o mensaje de que no se puede actualizar
      showErrorAlert("No se puede actualizar: concepto no válido.");
    }
  };

  
  const SkeletonTableRow = () => (
    <tr>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "60px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "150px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "100px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "70px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "200px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "100px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "60px" }}></div>
      </td>
    </tr>
  );

  return (
  <div className="pro-container">

    {/* ===================================================== */}
    {/* HEADER */}
    {/* ===================================================== */}

    <div className="pro-header">

      <div className="pro-header-left">

        <h2 className="pro-title">
          Conceptos
        </h2>

        <p className="pro-subtitle">
          Gestión y mantenimiento de conceptos
        </p>

      </div>

      <div className="pro-actions">

        <div className="pro-search">

          <i className="bi bi-search"></i>

          <input
            type="search"
            placeholder="Buscar concepto..."
            value={searchTerm}
            onChange={handleSearchTermChange}
          />

        </div>

        <button
          type="button"
          className="pro-btn-primary"
          title="Crear Nuevo concepto"
          onClick={() => openModal(null)}
        >

          <i className="bi bi-plus-circle"></i>

          Nuevo concepto

        </button>

      </div>

    </div>

    {/* ===================================================== */}
    {/* TABLE DESKTOP */}
    {/* ===================================================== */}

    <div className="pro-card d-none d-md-block">

      <div className="table-responsive">

        <table className="table pro-table">

          <thead>

            <tr>

              <th style={{ width: "10%" }}>
                ID
              </th>

              <th style={{ width: "25%" }}>
                Nombre
              </th>

              <th style={{ width: "40%" }}>
                Descripción
              </th>

              <th style={{ width: "10%" }}>
                Estado
              </th>

              <th style={{ width: "15%" }}>
                Acciones
              </th>

            </tr>

          </thead>

          <tbody>

            {loading ? (

              Array.from({ length: 15 }).map((_, index) => (
                <SkeletonTableRow key={index} />
              ))

            ) : (

              displayedConceptos.map((concepto) => (

                <tr key={concepto.conceptoId}>

                  <td>
                    #{concepto.conceptoId}
                  </td>

                  <td className="fw-semibold">
                    {concepto.conceptoNm}
                  </td>

                  <td
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={concepto.conceptoDesc}
                  >

                    {concepto.conceptoDesc?.length > 40
                      ? `${concepto.conceptoDesc.slice(0, 40)}...`
                      : concepto.conceptoDesc}

                  </td>

                  <td>

                    <span
                      className={`expediente-badge ${
                        concepto.estatus === "Activo"
                          ? ""
                          : "gender-badge"
                      }`}
                    >

                      {concepto.estatus}

                    </span>

                  </td>

                  <td>

                    <div className="pro-table-actions">

                      <button
                        type="button"
                        className="pro-action-btn primary"
                        title="Editar"
                        onClick={() => openModal(concepto)}
                      >

                        <i className="bi bi-pencil-square"></i>

                      </button>

                      <button
                        type="button"
                        className="pro-action-btn warning"
                        title="Eliminar"
                        // onClick={() => handleDelete(concepto.conceptoId)}
                      >

                        <i className="bi bi-trash"></i>

                      </button>

                    </div>

                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

      </div>

    </div>

    {/* ===================================================== */}
    {/* MOBILE CARDS */}
    {/* ===================================================== */}

    <div className="d-md-none">

      <div className="row">

        {loading ? (

          Array.from({ length: 5 }).map((_, index) => (

            <div className="col-12 mb-3" key={index}>

              <div className="mobile-patient-card">

                <div className="skeleton-line mb-3"></div>
                <div className="skeleton-line mb-3"></div>
                <div className="skeleton-line mb-3"></div>
                <div className="skeleton-line"></div>

              </div>

            </div>

          ))

        ) : (

          displayedConceptos.map((concepto) => (

            <div
              className="col-12 mb-3"
              key={concepto.conceptoId}
            >

              <div className="mobile-patient-card">

                <div className="mobile-card-top">

                  <div className="patient-info">

                    <div className="patient-avatar">

                      {concepto.conceptoNm?.charAt(0)}

                    </div>

                    <div>

                      <div className="patient-name">

                        {concepto.conceptoNm}

                      </div>

                      <div className="patient-id">

                        Concepto #{concepto.conceptoId}

                      </div>

                    </div>

                  </div>

                </div>

                <div className="mb-3">

                  <small className="text-muted d-block mb-1">

                    Descripción

                  </small>

                  <div>

                    {concepto.conceptoDesc}

                  </div>

                </div>

                <div className="mb-3">

                  <small className="text-muted d-block mb-1">

                    Estado

                  </small>

                  <span
                    className={`expediente-badge ${
                      concepto.estatus === "Activo"
                        ? ""
                        : "gender-badge"
                    }`}
                  >

                    {concepto.estatus}

                  </span>

                </div>

                <div className="mobile-card-actions">

                  <button
                    type="button"
                    className="pro-action-btn primary"
                    title="Editar"
                    onClick={() => openModal(concepto)}
                  >

                    <i className="bi bi-pencil-square"></i>

                  </button>

                  <button
                    type="button"
                    className="pro-action-btn warning"
                    title="Eliminar"
                    // onClick={() => handleDelete(concepto.conceptoId)}
                  >

                    <i className="bi bi-trash"></i>

                  </button>

                </div>

              </div>

            </div>

          ))

        )}

      </div>

    </div>

    {/* ===================================================== */}
    {/* PAGINATION */}
    {/* ===================================================== */}

    {!showForm && (

      <div className="pro-pagination">

        <nav aria-label="Page navigation example">

          <ul className="pagination modern-pagination">

            {/* PREVIOUS */}

            <li
              className={`page-item ${
                pageNumber === 0 ? "disabled" : ""
              }`}
            >

              <span
                className="page-link"
                onClick={() =>
                  handlePageChange({
                    selected: pageNumber - 1,
                  })
                }
                style={{
                  cursor:
                    pageNumber === 0
                      ? "not-allowed"
                      : "pointer",
                }}
              >

                <i className="bi bi-chevron-left"></i>

              </span>

            </li>

            {/* NUMBERS */}

            {Array.from(
              { length: Math.min(pageCount, 10) },
              (_, index) => (

                <li
                  key={index}
                  className={`page-item ${
                    pageNumber === index
                      ? "active"
                      : ""
                  }`}
                >

                  <span
                    className="page-link"
                    onClick={() =>
                      handlePageChange({
                        selected: index,
                      })
                    }
                  >

                    {index + 1}

                  </span>

                </li>

              )
            )}

            {/* NEXT */}

            <li
              className={`page-item ${
                pageNumber === pageCount - 1
                  ? "disabled"
                  : ""
              }`}
            >

              <span
                className="page-link"
                onClick={() =>
                  handlePageChange({
                    selected: pageNumber + 1,
                  })
                }
                style={{
                  cursor:
                    pageNumber === pageCount - 1
                      ? "not-allowed"
                      : "pointer",
                }}
              >

                <i className="bi bi-chevron-right"></i>

              </span>

            </li>

          </ul>

        </nav>

      </div>

    )}

    {/* ===================================================== */}
    {/* MODAL */}
    {/* ===================================================== */}

    {currentForm === "conceptoForm" &&
      selectedConceptoLocal && (
        <div className="main-content"></div>
      )}

    <Modal
      isOpen={modalOpen}
      toggle={closeModal}
      centered
      className="pro-modal"
    >

      <ModalHeader toggle={closeModal}>

        {isEditing
          ? "Editar Concepto"
          : "Nuevo Concepto"}

      </ModalHeader>

      <ModalBody>

        <Form>

          <FormGroup className="mb-3">

            <Label for="nombreConcepto">

              Nombre del Concepto

            </Label>

            <Input
              type="text"
              id="nombreConcepto"
              className="pro-input"
              value={formulario.nombreConcepto}
              onChange={(e) =>
                setFormulario({
                  ...formulario,
                  nombreConcepto: e.target.value,
                })
              }
            />

          </FormGroup>

          <FormGroup className="mb-3">

            <Label for="descripcionConcepto">

              Descripción

            </Label>

            <Input
              type="textarea"
              id="descripcionConcepto"
              className="pro-input"
              rows="4"
              value={formulario.descripcionConcepto}
              onChange={(e) =>
                setFormulario({
                  ...formulario,
                  descripcionConcepto: e.target.value,
                })
              }
            />

          </FormGroup>

          <FormGroup>

            <Label for="estatusConcepto">

              Estado

            </Label>

            <Input
              type="select"
              id="estatusConcepto"
              className="pro-input"
              value={formulario.estatusConcepto}
              onChange={(e) =>
                setFormulario({
                  ...formulario,
                  estatusConcepto: e.target.value,
                })
              }
            >

              <option value="activo">
                Activo
              </option>

              <option value="inactivo">
                Inactivo
              </option>

            </Input>

          </FormGroup>

        </Form>

      </ModalBody>

      <ModalFooter>

        <Button
          className="pro-btn-cancel"
          onClick={closeModal}
        >

          Cancelar

        </Button>

        <Button
          className="pro-btn-save"
          onClick={
            isEditing
              ? editarConcepto
              : guardarNuevoConcepto
          }
        >

          {isEditing
            ? "Guardar Edición"
            : "Guardar"}

        </Button>

      </ModalFooter>

    </Modal>

  </div>
);
  

};
export default ConceptosList;
